/** NotificationService.js
 *  Responsible for communicating with Firebase regarding notifications.
 */

import {doc, deleteDoc, updateDoc} from "firebase/firestore";
import {db} from "../firebase";

// Deletes a notification that sent by ID
export const deleteNotification = async (notificationId) => {
    try {
        const notifRef = doc(db, "notifications", notificationId);
        await deleteDoc(notifRef);
        console.log("התראה נמחקה:", notificationId);
    } catch (error) {
        console.error("שגיאה במחיקת ההתראה:", error);
    }
};

export const markNotificationAsRead = async (notificationId) => {
    const notificationRef = doc(db, "notifications", notificationId);
    await updateDoc(notificationRef, {isRead: true});
};
